export default __webpack_public_path__ + "static/media/Vector-4.0f12a90b.svg";